import type { RedirectRouteRelative } from '@/utilities/routers.ts'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeNotificationCreate,
  detail: routeNotificationDetail,
  home: routeNotificationsHome,
  root: routeNotificationsRoot,
} = createDoctypeRoutes({
  createName: 'new-notification',
  createPath: 'new-notification',
  detailName: 'notificationDetail',
  doctype: DOCTYPES.NOTIFICATION,
  homeName: 'notifications',
  path: 'notification',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/notifications/AddNotification.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/notifications/ViewNotification.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/automation/ViewAutomation.vue'),
  },
})

const redirectNotificationsDetail: RedirectRouteRelative = {
  name: routeNotificationDetail.name,
}

export {
  redirectNotificationsDetail,
  routeNotificationCreate,
  routeNotificationDetail,
  routeNotificationsHome,
  routeNotificationsRoot,
}
